"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatasetDelta = exports.translateRange = exports.getAscendingList = void 0;
/**
 * Sorting function to sort from lowest to highest. Copies the array for safety.
 * @param {number[]} data The numbers to sort.
 * @returns {number[]} The sorted data.
 */
var getAscendingList = function (data) {
    return __spreadArray([], data, true).sort(function (x, y) { return x - y; });
};
exports.getAscendingList = getAscendingList;
/**
 * Translates an entire data range to another. (ie. translate all of the data to fit within 0 - 100)
 *
 * @param {number[]} data The data to translate.
 * @param {number} min The minimum value of the new range
 * @param {number} max The maximum value of the new range.
 * @param {?number} oldMin Old minimum range. If left out, uses the lowest value in the dataset.
 * @param {?number} oldMax Old minimum range. If left out, uses the lowest value in the dataset.
 */
var translateRange = function (data, min, max, oldMin, oldMax) {
    var oldMinVal;
    var oldMaxVal;
    if (typeof oldMin === "undefined" || typeof oldMax === "undefined") {
        var ordered = (0, exports.getAscendingList)(data);
        oldMinVal = ordered[0];
        oldMaxVal = ordered[ordered.length - 1];
    }
    else {
        oldMinVal = oldMin;
        oldMaxVal = oldMax;
    }
    var newRange = max - min;
    var oldRange = oldMaxVal - oldMinVal;
    return data.map(function (val) { return ((val - oldMinVal) * newRange) / oldRange + min; });
};
exports.translateRange = translateRange;
/**
 * Gets the percentage of the lowest number to the highest number in a dataset.
 * @param {number[]} dataset The dataset.
 * @returns {number} The percentage difference between the highest and lowest values.
 */
var getDatasetDelta = function (data) {
    var ordered = (0, exports.getAscendingList)(data); // Sort from least to highest
    return ordered[0] / ordered[ordered.length - 1];
};
exports.getDatasetDelta = getDatasetDelta;
//# sourceMappingURL=data.js.map